import { useTranslation } from 'react-i18next';

import type { ServiceAgreementTermsEnum } from '../api/generated/pm';
import type { ReviewResultStatus } from '../providers/ReviewResultContext/review-result.types';

type UseAgreementResultStatusTextParams = {
  result: ReviewResultStatus | null;
  dealerName?: string;
  customerName?: string;
  terms?: ServiceAgreementTermsEnum;
};

export function useAgreementResultStatusText({
  result,
  dealerName,
  customerName,
  terms,
}: UseAgreementResultStatusTextParams): string {
  const { t } = useTranslation();

  const translationParams = {
    ns: 'common',
    dealerName,
    customerName,
    context: terms,
  };

  return result === 'accepted'
    ? t('serviceAgreement.status.accepted', translationParams)
    : t('serviceAgreement.status.declined', translationParams);
}
